import { OBJECTS_NAV_WIDTH_STORAGE_KEY } from './constants/objectsNavLayout';
import { client } from './oauth';

/**
 * Mirrored by the inline splash script in index.html — keep the key, the wording and the window in
 * sync. That splash paints from static markup before any bundle has loaded, so storage is the only
 * channel it can read. The value is a timestamp rather than a flag so that a logout the user
 * abandons cannot linger and mislabel a later boot as a sign-out (CO4-3360).
 */
const LOGOUT_IN_PROGRESS_KEY = 'co4:logging-out';
const LOGOUT_TAGLINE = 'Logging out...';

/**
 * Clears UI state that must not survive the next login, then signs out.
 */
export async function logoutAndClearSessionUi(): Promise<void> {
  try {
    localStorage.removeItem(OBJECTS_NAV_WIDTH_STORAGE_KEY);
  } catch {
    // ignore
  }

  try {
    sessionStorage.setItem(LOGOUT_IN_PROGRESS_KEY, String(Date.now()));
  } catch {
    // ignore
  }

  // A failed auth callback logs out with the splash already on screen (index.tsx); that path
  // never reloads, so fix the tagline in place too.
  const tagline = document.getElementById('initial-loading-tagline');

  if (tagline) {
    tagline.dataset.tagline = LOGOUT_TAGLINE;
  }

  await client.logout();
}
